import { handleFileUpload } from "/common/client/js/utils/formUtils.js";
import { setDateListenr } from "../utils/dateLimiter.js";
import { AddressAutocomplete } from "/common/client/js/utils/address-autocomplete.js";
import * as sidebar from "/common/client/js/utils/sidebar.js";
import { initTerminListener, initSelects, initWarrantyNumberListener, 
    initCustomerNumberListener, initDefectiveDeviceCount, initAddButtons, 
    initSubmitListener, initGuaranteelistener, initObserver,
    initCustomerTypeListener, initBillingAddressListener } 
    from "../utils/listeners.js";

document.addEventListener('DOMContentLoaded', init);

function init() {
    initSelects();
    initWarrantyNumberListener();
    initCustomerNumberListener();
    // initObserver();
    // initDefectiveDeviceCount();
    initAddButtons();
    handleFileUpload();
    setDateListenr();
    initGuaranteelistener();
    initTerminListener();
    const buildingAddressAutocomplete = new AddressAutocomplete('building');
    const customerAddressAutocomplete = new AddressAutocomplete('customer');
    const billingAddressAutocomplete = new AddressAutocomplete('billing');
    const autocompletes = [buildingAddressAutocomplete, customerAddressAutocomplete, billingAddressAutocomplete];
    initCustomerTypeListener();
    initBillingAddressListener(billingAddressAutocomplete);
    initSubmitListener(autocompletes);
}
